import React, {Fragment} from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Accordion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.config = {
      types : [
        {
          title: 'default',
          isDefault: true,
        },
        'onlyChild'
      ],
      modifiers : [],
      states : []
    }

    this.data = []

    this.state = {
      data: this.data,
      currentOpenedIndex: null
    };
    this.handleBoxClick = this.handleBoxClick.bind(this);
}

  handleBoxClick(e, index) {
    const { data } = this.state;
    const onOpen = this.config.onOpen
    const onClose = this.config.onClose
    const currentOpenedIndex = this.state.currentOpenedIndex

    if((currentOpenedIndex !== null) && currentOpenedIndex >= 0 && currentOpenedIndex !== index){
      data[currentOpenedIndex].isOpen = false;
      onClose && onClose(e, currentOpenedIndex)
    }
    
    let isOpen = !data[index].isOpen
    data[index].isOpen = isOpen;
    
    this.setState({
      data, 
      currentOpenedIndex: index
    }, function(){});
    
    isOpen && onOpen && onOpen(e, index)
    !isOpen && onClose && onClose(e, index)
  }

  renderAccordion(dataAccordion) {
    return dataAccordion.map((item, index) => {
      let currentClassName = 'mdn-Accordion-box';
      return (
        <Fragment key={index}>
          <div className={`${currentClassName}`+ ((item.isOpen) ? ' is-expanded' : '') }>
            <a className="mdn-Accordion-toggle mdn-Text mdn-Text--body mdn-u-color--danger" onClick={(e) => { this.handleBoxClick(e, index); }} {...item.props}>
              {item.title}
              <span className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg"/>
            </a>
            <div className="mdn-Accordion-content">
              {item.content}
            </div>
          </div>
        </Fragment>
      );
    });
  }  
  
  componentDidMount() {
    this.setState({
      data: this.data
    });
  }

  render() {
    let { config, ...rest } = this.props
    config = config || {}
    this.config.onClose = this.props.onClose || config.onClose;
    this.config.onOpen = this.props.onOpen || config.onOpen;

    this.data = this.props.data || this.props.dataAccordion || config.data;

    return <div {...rest} className={resolveProps(this.props, this.config, 'Accordion')}>
      {this.renderAccordion(this.state.data)}
    </div>
  }
}

Accordion.propTypes = {
  config: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  dataAccordion: PropTypes.arrayOf(PropTypes.object), // backwards compatibility
  className : PropTypes.string
}